import Time from "./Time";

class TimePeriod {
  constructor(
    private readonly _from: Time = new Time(),
    private readonly _to: Time = new Time(),
  ) {
  }

  public within(time: Time): boolean {
    return this._from.isSameOrBefore(time) && this._to.isAfter(time);
  }

  get from() {
    return this._from;
  }

  get to() {
    return this._to;
  }
}

export default TimePeriod;
